// Dollar figures that only a super admin would see stay hidden unless the URL
// asks for them with `costs=true`, so a screen-shared super-admin view shows
// no prices by default (BOO-376). Customer-visible spend is unaffected.

// Only the literal `costs=true` counts (`costs=1` does not).
export function wantsCosts(search: Record<string, unknown>): boolean {
  return search.costs === true || search.costs === "true";
}

// The Channels tab Spend column: shown where the customer would see it, and
// to a super admin elsewhere only with `costs=true`.
export function channelSpendVisible(opts: {
  customerVisible: boolean;
  superAdminView: boolean;
  costs: boolean;
}): boolean {
  return opts.customerVisible || (opts.superAdminView && opts.costs);
}
